import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import cx from "classnames";
import { Select, Option } from "../Select";
import { FieldDescription } from "../FieldDescription";
import { FieldLabel } from "../FieldLabel";
import styles from "./DropDownFieldType.less";
export var DropDownFieldType =
/*#__PURE__*/
function (_Component) {
  _inherits(DropDownFieldType, _Component);

  function DropDownFieldType() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropDownFieldType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropDownFieldType)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (name, value) {
      if (_this.props.onChange) {
        _this.props.onChange(name, value, _this.props.datatype);
      }
    });

    return _this;
  }

  _createClass(DropDownFieldType, [{
    key: "render",
    value: function render() {
      return React.createElement("label", {
        className: cx(styles.DropDownFieldType, this.props.className)
      }, React.createElement(FieldLabel, {
        label: this.props.label,
        required: this.props.required,
        tag: this.props.tag,
        tooltip: this.props.tooltip
      }), React.createElement(Select, {
        name: this.props.name,
        loading: this.props.loading,
        value: this.props.value || "0",
        onSelect: this.onSelect
      }, React.createElement(Option, {
        value: this.props.defaultOptValue || "0",
        text: this.props.defaultOptText || "— None —"
      }), this.props.children ? this.props.children : this.props.options.map(function (opt, i) {
        return React.createElement(Option, _extends({
          key: i
        }, opt));
      })), this.props.description && React.createElement(FieldDescription, {
        description: this.props.description
      }));
    }
  }]);

  return DropDownFieldType;
}(Component);